export default "__VITE_ASSET__D4f7592L__"